import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Popover from '@radix-ui/react-popover';
import { useFootnote } from './reader.js';
/**
 * Renders the active footnote (from `reader:footnote`) as a Radix `Popover`
 * so it gets a focus scope, escape-to-close and outside-click dismissal.
 * Unanchored (the noteref lives inside the reader iframe), so it centres via
 * the consumer's `data-pore-footnote` styles.
 */
export function FootnotePopover({ className }) {
    const [footnote, clear] = useFootnote();
    return (_jsxs(Popover.Root, { open: !!footnote, onOpenChange: (o) => !o && clear(), children: [_jsx(Popover.Anchor, {}), _jsx(Popover.Portal, { children: _jsxs(Popover.Content, { className: className ?? 'footnote', "data-pore-footnote": true, role: "dialog", "aria-label": "Footnote", onOpenAutoFocus: (e) => e.preventDefault(), children: [_jsx(Popover.Close, { className: "footnote__close", "aria-label": "Close", "data-pore-footnote-close": true, children: "\u00D7" }), footnote ? _jsx("div", { dangerouslySetInnerHTML: { __html: footnote.html } }) : null] }) })] }));
}
//# sourceMappingURL=footnote-popover.js.map